import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import SiteScripts from "@/components/SiteScripts";
import Home from "@/pages/Home";
import EventDetail from "@/pages/EventDetail";
import ListEvent from "@/pages/ListEvent";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";

function App() {
  return (
    <div className="App">
      <AppProvider>
        <SiteScripts />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/event/:id" element={<EventDetail />} />
            <Route path="/list-event" element={<ListEvent />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AppProvider>
    </div>
  );
}

export default App;
